import { render, staticRenderFns } from "./PictureDialog.vue?vue&type=template&id=1dda90b0"
import script from "./PictureDialog.vue?vue&type=script&lang=js"
export * from "./PictureDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports